__turbopack_context__.v({
  "articleCard": "ArticleCard-module__rfEdSa__articleCard",
  "author": "ArticleCard-module__rfEdSa__author",
  "date": "ArticleCard-module__rfEdSa__date",
  "image": "ArticleCard-module__rfEdSa__image",
  "imageWrapper": "ArticleCard-module__rfEdSa__imageWrapper",
  "subtitle": "ArticleCard-module__rfEdSa__subtitle",
  "title": "ArticleCard-module__rfEdSa__title",
});
